import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

export const fetchStaffGroups = createAsyncThunk(
  "staffGroups/fetchAll",
  async () => {
    const { data } = await api.get(API_ENDPOINTS.security.staffGroups.getAll);
    return data;
  }
);

// — Get one by ID
export const fetchStaffGroupById = createAsyncThunk(
  "staffGroups/fetchById",
  async (staffGroupId) => {
    const { data } = await api.get(
      API_ENDPOINTS.security.staffGroups.getById + staffGroupId
    );
    return data;
  }
);

// — Create a new staff‐group
export const createStaffGroup = createAsyncThunk(
  "staffGroups/create",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.staffGroups.create,
      payload
    );
    return data;
  }
);

export const createStaffGroupMember = createAsyncThunk(
  "staffGroupsMembers/create",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.staffGroupMembers.create,
      payload
    );
    return data;
  }
);

// — Update an existing staff‐group
export const updateStaffGroup = createAsyncThunk(
  "staffGroups/update",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.staffGroups.update,
      payload
    );
    return data;
  }
);

// — Delete a staff‐group
export const deleteStaffGroup = createAsyncThunk(
  "staffGroups/delete",
  async (staffGroupId) => {
    await api.delete(
      API_ENDPOINTS.security.staffGroups.deleteActionPaneItems + staffGroupId
    );
    return staffGroupId;
  }
);
